import { PredicateActions } from './PredicateActions';

/** A read-only predicate rendered as a single plain box — its plain-language text — with the row actions to
 *  the right. Shared by the raw-SQL clause (its `label`, plus a "Show SQL" viewer via `onShowSql`) and the
 *  read-only attribute clause (its `sentence`). No input chrome: the box isn't clickable, so it never greys on
 *  `disabled`; only the delete action is gated. */
export function ReadOnlyClause({
  text,
  onShowSql,
  onRemove,
  disabled = false,
}: {
  text: string;
  onShowSql?: () => void;
  onRemove?: () => void;
  disabled?: boolean;
}) {
  return (
    <div className="flex w-full min-w-0 items-center gap-2">
      {/* The box keeps its natural width (`w-max`) and scrolls inside this flex-1 track, so a long
          sentence never pushes the row actions off-screen. */}
      <div className="scrollbar-none min-w-0 flex-1 overflow-x-auto">
        <div className="flex h-7 w-max items-center rounded-md border border-grey-100 bg-background px-2 text-sm font-medium text-grey-800">
          <span>{text}</span>
        </div>
      </div>
      <PredicateActions onShowSql={onShowSql} onRemove={onRemove} disabled={disabled} />
    </div>
  );
}
